import { render } from "./PreloderComponent.vue?vue&type=template&id=6032bf9e&scoped=true"
import script from "./PreloderComponent.vue?vue&type=script&lang=js"
export * from "./PreloderComponent.vue?vue&type=script&lang=js"

import "./PreloderComponent.vue?vue&type=style&index=0&id=6032bf9e&scoped=true&lang=css"

import exportComponent from "C:\\frontend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6032bf9e"]])

export default __exports__